import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { SecretList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { SecretCreateInitializer } from "./create/initializer";
import { SecretDetailInitializer } from "./detailInitializer";

const SecretRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<SecretList />} />
        <Route path={`-create/*`} element={<SecretCreateInitializer />} />
        <Route path={`:secret/*`} element={<SecretDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default SecretRoute;
